import ReactGA from 'react-ga';

export class GoogleAnalyticsService {

    static init() {
        ReactGA.initialize([{
            trackingId: 'UA-88292806-1',
            titleCase: false,
            gaOptions: {
                sampleRate: 10
            }
        }]);
    }

    static trackEvent(data: any = {}) {
        ReactGA.event(data);
    }

    static trackPageView() {
        ReactGA.pageview(window.location.pathname, ['testium']);
    }
}
